<template>
  <baidu-map class="map" :center="{lng: 113.844, lat: 34.73034}" :zoom="20" high-resolution dragging :scroll-wheel-zoom="true">
    <bm-marker :position="{lng: 113.844, lat: 34.73034}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
      <bm-label content="中科智谷"  :offset="{width: -15, height: 30}"/>
    </bm-marker>
  </baidu-map>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
// $sun:75/192;
$sun:100/192;
$md:75/192*2;
@media only screen and (max-width: 750px) {
  .map {
  width: 100%;
  height: 239px/$md;
}

}
// PC端/
@media only screen and (min-width: 756px) {
  .map {
  width: 100%;
  height: 300px*$sun;
}
}

</style>
